import { render, staticRenderFns } from "./RunnitBoardMemberChip.vue?vue&type=template&id=233ae828&scoped=true"
import script from "./RunnitBoardMemberChip.vue?vue&type=script&lang=ts"
export * from "./RunnitBoardMemberChip.vue?vue&type=script&lang=ts"
import style0 from "./RunnitBoardMemberChip.vue?vue&type=style&index=0&id=233ae828&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233ae828",
  null
  
)

export default component.exports